import { all, takeLatest } from 'redux-saga/effects';
import { AppTypes } from './AppRedux';
import { startup, loadAppdata } from './AppSaga';
import { CouponsTypes } from './CouponsRedux';
import { fetchCoupons, fetchCoupon } from './CouponsSaga';
import { PropertyTypes } from './PropertyRedux';
import { fetchProperty, updateLocalProperty } from './PropertySaga';
import { UsersTypes } from './UsersRedux';
import { fetchUsers, fetchUser } from './UsersSaga';
import { ClientTypes } from './ClientRedux';
import { fetchClient } from './ClientSaga';
import { BookingTypes } from './BookingRedux';
import { fetchBooking } from './BookingSaga';
import { RegionsTypes } from './RegionsRedux';
import { fetchRegions, fetchRegion } from './RegionsSaga';

import { AuthTypes } from './AuthRedux';
import {
  storeToken,
  clearToken,
  refreshAuthToken,
  loadUser,
  storeUser
} from './AuthSaga';

/**
 * rootSaga
 */

//TODO: need to replace with takeLates, because only one func is called in sagas.
export default function* root() {
  yield all([
    takeLatest(AppTypes.STARTUP, startup),
    takeLatest(AppTypes.SET_APP_DATA_LOAD_REQUEST, loadAppdata),
    takeLatest(AuthTypes.SET_LOGGED_IN, storeToken),
    takeLatest(AuthTypes.SET_LOGGED_OUT, clearToken),
    takeLatest(AuthTypes.SET_REFRESH_AUTH_REQUEST, refreshAuthToken),
    takeLatest(AuthTypes.SET_USER_LOAD_REQUEST, loadUser),
    takeLatest(AuthTypes.SET_USER, storeUser),
    takeLatest(UsersTypes.FETCH_USERS, fetchUsers),
    takeLatest(UsersTypes.LOAD_USER_REQUEST, fetchUser),
    takeLatest(PropertyTypes.LOAD_PROPERTY_REQUEST, fetchProperty),
    takeLatest(PropertyTypes.UPDATE_LOCAL_PROPERTY, updateLocalProperty),
    takeLatest(ClientTypes.LOAD_CLIENT_REQUEST, fetchClient),
    takeLatest(CouponsTypes.FETCH_COUPONS, fetchCoupons),
    takeLatest(CouponsTypes.LOAD_COUPON_REQUEST, fetchCoupon),
    takeLatest(BookingTypes.LOAD_BOOKING_REQUEST, fetchBooking),
    takeLatest(RegionsTypes.FETCH_REGIONS, fetchRegions),
    takeLatest(RegionsTypes.LOAD_REGION_REQUEST, fetchRegion)
  ]);
}
